import React from "react";
import LandingPageMain from "../landingPage/components/jsx/LandingPageMain";
import InputEndHelper from "./components/jsx/InputEndHelper";

const InputEnd = () => {
  return (
    <>
      <div className="inputPage-background">
        <LandingPageMain />
        <InputEndHelper />
      </div>
    </>
  );
};

export default InputEnd;
